import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";

var _hoisted_1 = /*#__PURE__*/_createElementVNode("form", {
  "class": "navbar-search navbar-search-dark form-inline mr-3 d-none d-md-flex ml-lg-auto"
}, null, -1);

var _hoisted_2 = {
  "class": "navbar-nav align-items-center d-none d-md-flex"
};
var _hoisted_3 = {
  "class": "nav-item dropdown"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_user_login_view = _resolveComponent("user-login-view");

  var _component_base_nav = _resolveComponent("base-nav");

  return _openBlock(), _createBlock(_component_base_nav, {
    "class": "navbar-top navbar-dark",
    id: "navbar-main",
    "show-toggle-button": true,
    expand: ""
  }, {
    "default": _withCtx(function () {
      return [_hoisted_1, _createElementVNode("ul", _hoisted_2, [_createElementVNode("li", _hoisted_3, [_createVNode(_component_user_login_view)])])];
    }),
    _: 1
  });
}